import { Lock, ArrowRight } from "lucide-react";

export const PrivateOpportunitiesSection = () => {
  return (
    <section 
      className="py-16 md:py-24 lg:py-32 bg-[#0A0A0B] relative overflow-hidden"
      data-testid="private-opportunities-section"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      
      {/* Corner accents */}
      <div className="absolute top-12 left-12 w-20 h-20 border-l border-t border-[#D4AF37]/15 hidden lg:block" />
      <div className="absolute bottom-12 right-12 w-20 h-20 border-r border-b border-[#D4AF37]/15 hidden lg:block" />
      
      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 lg:px-12 text-center">
        {/* Icon */}
        <div className="w-16 h-16 md:w-20 md:h-20 border border-[#D4AF37]/30 flex items-center justify-center mx-auto mb-6 md:mb-8">
          <Lock className="w-8 h-8 md:w-10 md:h-10 text-[#D4AF37]" />
        </div>
        
        {/* Header */}
        <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
          Exclusive Access
        </span>
        <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-white mt-4 md:mt-6 leading-tight">
          Private Property
          <span className="block text-[#D4AF37] italic">Opportunities</span>
        </h2>
        <div className="w-16 md:w-20 h-px bg-[#D4AF37] mx-auto mt-6 md:mt-8 mb-8 md:mb-10" />
        
        {/* Description */}
        <p className="text-white/60 text-sm md:text-base lg:text-lg leading-relaxed mb-8 md:mb-10 max-w-3xl mx-auto">
          From time to time, our firm is engaged to advise on carefully selected property 
          opportunities introduced privately to our clients. These opportunities are not 
          publicly listed and are only discussed with clients who have engaged our firm 
          for legal advisory services.
        </p>
        
        {/* Statement box */}
        <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/20 p-5 md:p-6 mb-10 md:mb-12 max-w-2xl mx-auto">
          <p className="text-white/80 text-sm md:text-base italic">
            All opportunities are subject to independent legal due diligence before being presented to clients.
          </p>
        </div>
        
        {/* CTA Button */}
        <a
          href="https://wa.me/2348032143826?text=Hello%204ACES%20Attorneys%2C%20I%20saw%20your%20website%20and%20would%20like%20to%20discuss%20a%20property%20transaction%20in%20Nigeria."
          className="group inline-flex items-center justify-center gap-3 bg-[#D4AF37] text-[#0A0A0B] px-8 md:px-10 py-4 md:py-5 text-sm tracking-[0.1em] font-bold hover:bg-[#C5A028] transition-all duration-300"
          data-testid="opportunities-cta"
        >
          Discuss Investment Opportunities
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </a>
      </div>
      
      {/* Decorative bottom line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
    </section>
  );
};
